import React from 'react';
import {
  getBezierPath, getMarkerEnd, getEdgeCenter, EdgeText
} from 'react-flow-renderer';
import { makeStyles, Box } from '@material-ui/core';
import IconRenderer from '../../../components/IconRenderer';


const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }
}));

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data,
  arrowHeadType,
  markerEndId,
}: any) => {
  const edgePath = getBezierPath({
    sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition
  });
  const [centerX, centerY] = getEdgeCenter({
    sourceX, sourceY, targetX, targetY
  });
  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);

  return (
    <>
      <path id={id} style={style} className="react-flow__edge-path" d={edgePath} markerEnd={markerEnd} />
      <EdgeText
        x={centerX}
        y={centerY}
        labelStyle={{
          color: 'black',
          fontSize: 14,
        }}
        labelBgPadding={[4, 0]}
        label="+"
      />
    </>
  );
};

export default CustomEdge;
